export default "__VITE_ASSET__v0yB6tGc__"